define(function (require) {
    "use strict";

    var $                = require('jquery');
    var _                = require('underscore');
    //var io               = require('socketio');
    var AppConfig        = require('config/application');
    var Backbone         = require('backbone');

    var Connection = function (properties) {
        _.bindAll(this, "_authorize", "_fireMessageReceived", "_reconnect", "_disconnect");
        this.reconnecting = false;
        this.connection     = null;
        this.eventListeners = {};
    };


    var getTokenAndReconnect = _.debounce(function () {
        var that = this;
        Backbone.ajax({
            url: AppConfig.host + '/rest/system/ws/auth',
            type: 'POST',
            contentType: 'application/json',
            success: function ( response ) {
                if (response.status = 1) {
                    app.storage.write('wsToken', response.token);
                    that.connect();
                }
            }
        });
    }, 10000);

    var reconnect = _.debounce(function () {
        var that = this;
        that.connect();
    }, 10000);


    Connection.prototype = {
        connect: function () {
            var wsToken = app.storage.read('wsToken');
            if (wsToken) {
                this.connection = new WebSocket(AppConfig.notify.url + '?token=' + wsToken);
                this.connection.addEventListener('message', this._fireMessageReceived.bind(this));
                this.connection.addEventListener('close', this._disconnect.bind(this));
                this.connection.addEventListener('open', this._connect.bind(this));
            } else {
                getTokenAndReconnect.call(this);
            }

            return this;
        },

        publish: function ( message ) {
            this.connection.send(message);
        },

        _authorize: function () {
            if (!app.storage.read('wsToken'))
                return;

            this.connection.send('//auth ' + app.storage.read('wsToken'));
            //this.connection.send('//currentsite ' + app.curProject.id);
            this.connection.send('//currentaccount ' + app.AUTH_ID);

        },

        on: function ( eventName, callback ) {
            if (typeof this.eventListeners[eventName] === 'undefined')
                this.eventListeners[eventName] = [callback];
            else
                this.eventListeners[eventName].push(callback);
        },

        off: function( eventName, callback ) {
            if (typeof this.eventListeners[eventName] !== 'undefined') {
                _.each(this.eventListeners[eventName], function(f, index) {
                    if (f == callback) {
                        this.eventListeners[eventName].splice(index, 1);
                    }
                }.bind(this));
            }
        },

        _fireMessageReceived: function ( data ) {
            var payload = data.data;
            var message;
            _.each(this.eventListeners['message:received'], function ( f ) {
                if (typeof payload == 'string') {
                    payload = JSON.parse(payload);
                    if (payload.message) {
                        message = payload.message;
                    }
                }
                f(message);
            });
        },

        _connect: function () {
            if (this.reconnecting) {
                this._reconnect.call(this);
                this.reconnecting = false;
            }

            _.each(this.eventListeners['connect'], function ( f ) {
                f();
            });
        },

        _disconnect: function ( event ) {
            if (!event.wasClean || (event.code !== 1000 && event.code !== 4030)) {
                this.connection.close();
                reconnect.call(this);
            }
            if (event.code === 4030) {
                this.connection.close();
                getTokenAndReconnect.call(this);
            }
            if (event.wasClean && event.code === 1000) {
                this.connection.close();
                _.each(this.eventListeners['disconnect'], function ( f ) {
                    f();
                });
            }
        },


        _reconnect: function () {
            _.each(this.eventListeners['reconnect'], function ( f ) {
                f();
            });
        }
    };


    return Connection;
});